var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppiconRaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1861_14678",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1861_14678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -30,
    width: 180,
    height: 180,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8663 16.6667H51.1441L34.3174 60H53.0396L69.8663 16.6667ZM46.5678 76.6667H27.8456L17.5 103.309H36.2223L46.5678 76.6667Z",
    fill: "url(#paint0_linear_1861_14678)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.967 16.6667H69.6893L86.516 60H67.7937L50.967 16.6667ZM74.2655 76.6667L84.6111 103.309H103.333L92.9878 76.6667H74.2655Z",
    fill: "url(#paint1_linear_1861_14678)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1861_14678",
    x1: 41.3029,
    y1: 16.6667,
    x2: 41.3029,
    y2: 103.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CDC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1861_14678",
    x1: 79.6666,
    y1: 24.1664,
    x2: 81.3333,
    y2: 101.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CABE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppiconRaw);
export default __webpack_public_path__ + "static/media/appicon_raw.cb0e8e53ba09de7dd5b9b111831909d2.svg";
export { ForwardRef as ReactComponent };